import { useClubCurrency } from '@sweetspot/shared/util/hooks'
import i18n from 'i18next'

export const withClubCurrency = (Component) => {
  return function WithWrapper(props) {
    const [currencyCode] = useClubCurrency()
    return <Component lang={i18n.language} currentClubCurrency={currencyCode} {...props} />
  }
}
